import { Controller } from "@hotwired/stimulus"
import lottie from "lottie-web"

export default class extends Controller {
  static targets = ["container"]

  initialize() {
    this.containerTargets.forEach((element) => {
      element.innerHTML = ""
    })

    lottie.loadAnimation({
      container: document.getElementById("paynow"),
      renderer: "svg",
      path: "/animations/connect-payment.json",
      loop: true,
      autoplay: true,
    })

    lottie.loadAnimation({
      container: document.getElementById("paylater"),
      renderer: "svg",
      path: "/animations/connect-paylater.json",
      loop: true,
      autoplay: true,
    })

    lottie.loadAnimation({
      container: document.getElementById("plan"),
      renderer: "svg",
      path: "/animations/connect-plan.json",
      loop: true,
      autoplay: true,
    })
  }
}
